/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNodeGroup = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 2a3.001 3.001 0 0 1 2.966 2.543l2.076 1.186A3 3 0 0 1 22 8a2.998 2.998 0 0 1-2 2.826v2.349a2.998 2.998 0 1 1-2.958 5.096l-2.076 1.186a3 3 0 0 1-5.933 0L6.957 18.27A2.985 2.985 0 0 1 5 19a3 3 0 0 1-1-5.826v-2.349A2.998 2.998 0 1 1 6.957 5.73l2.076-1.186A3.002 3.002 0 0 1 12 2zm0 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-4.049-2.536a3.014 3.014 0 0 1 0 1.071l1.514.864A3.004 3.004 0 0 1 11 16.174v-1.349a2.99 2.99 0 0 1-.958-.555zm6.006-1.194c-.28.24-.602.43-.957.555v1.349c.64.226 1.177.662 1.534 1.225l1.514-.865a3.014 3.014 0 0 1 0-1.07zM5 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm14 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-4.049-3.536a3.015 3.015 0 0 1 0 1.071l2.091 1.194c.28-.24.603-.43.958-.555v-2.349a2.99 2.99 0 0 1-.959-.555zM6.957 10.27c-.28.24-.602.43-.957.555v2.349c.354.125.678.314.957.555l2.09-1.195a3.018 3.018 0 0 1 0-1.07zM12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM7.951 7.464a3.015 3.015 0 0 1 0 1.071l2.091 1.194c.28-.24.603-.43.958-.555V7.825A3.003 3.003 0 0 1 9.465 6.6zm6.583-.864A3.001 3.001 0 0 1 13 7.825v1.349c.354.125.678.314.957.555l2.09-1.195a3.014 3.014 0 0 1 0-1.07zM5 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm14 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-7-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNodeGroup as NodeGroup };
